export default "__VITE_ASSET__BBQAc6Pc__"